import { useAuth0 } from "@auth0/auth0-react";
import {
  RouterProvider as TanStackRouterProvider,
  type AnyRouter,
} from "@tanstack/react-router";
import { useClient } from "urql";

type RouterProviderProps = {
  router: AnyRouter;
};

export function RouterProvider({ router }: RouterProviderProps) {
  const { user } = useAuth0();
  const urqlClient = useClient();

  return (
    <TanStackRouterProvider
      router={router}
      context={{ urqlClient, userId: user?.sub ?? "" }}
    />
  );
}
